var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top"},[_vm._v("错误页")]),_c('van-empty',{attrs:{"description":"暂无数据，请先登录"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }